export default __webpack_public_path__ + "assets/cart-component.10d8dfb1.svg";